import { isPostalCode } from 'validator';

export const isValidPostalCode = (value, country) => {
    try {
        return isPostalCode(value, country);
    } catch (error) {
        console.debug(error);
        return value.length > 0;
    }
};
